import { BasicAuthenticationClient } from '@frontend/authentication-v2';

import { useAppDispatch, useAppSelector } from '../redux/store';
import { endUserSession } from '../redux/terminal-navigation-slice';
import { useKioskNavigate } from '../utils/kiosk-navigation';

interface ViewProps {
    user?: any;
    onLogout: () => void;
}

const useKioskUserModal = (): ViewProps => {
    const dispatch = useAppDispatch();
    const navigate = useKioskNavigate();
    const navigationState = useAppSelector((state) => state.navigation);

    const onLogout = () => {
        if (navigationState.user?.auth.jwt_token) {
            BasicAuthenticationClient.logout(navigationState.user.auth.jwt_token);
        }
        dispatch(endUserSession());
        navigate('/');
    };

    return {
        user: navigationState.user?.user,
        onLogout
    };
};

export default useKioskUserModal;
